export const PROJECTS = [
  {
    slug: "rooms",
    index: "01",
    name: "KEDE-Rooms",
    image: "https://images.unsplash.com/photo-1576354302919-96748cb8299e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMGhvdGVsJTIwcm9vbSUyMGludGVyaW9yfGVufDB8fHx8MTc4ODE4ODQ4Nnww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7",
    height: "h-96 md:h-[30rem]",
    en: {
      tagline: "Boutique stays steps from Shanzu Beach",
      desc: "Bright, spotless rooms and apartments minutes from the white sands of Shanzu Beach — Danish-standard comfort delivered with Kenyan warmth.",
      features: ["Daily housekeeping by KEDE-Cleaning", "High-speed Wi-Fi in every room", "Fresh juice breakfasts by KEDE-Juice"],
    },
    sw: {
      tagline: "Malazi ya kifahari karibu na ufuo wa Shanzu",
      desc: "Vyumba na ghorofa safi na vya kung'aa, dakika chache kutoka mchanga mweupe wa ufuo wa Shanzu — starehe za kiwango cha Denmark kwa ukarimu wa Kenya.",
      features: ["Usafi wa kila siku kutoka KEDE-Cleaning", "Wi-Fi ya haraka kila chumba", "Kifungua kinywa cha juisi freshi kutoka KEDE-Juice"],
    },
  },
  {
    slug: "water",
    index: "02",
    name: "KEDE-Water",
    image: "https://images.unsplash.com/photo-1523362628745-0c100150b504?auto=format&fit=crop&q=80",
    span: "md:col-span-5",
    height: "h-96 md:h-[30rem]",
    en: {
      tagline: "Pure drinking water, delivered",
      desc: "KEDE-Water purifies, bottles and delivers safe drinking water to homes, shops and offices across Shanzu — hydration you never have to think about.",
      features: ["Purified & quality-tested drinking water", "Home & office delivery across Shanzu", "Affordable refill station"],
    },
    sw: {
      tagline: "Maji safi ya kunywa, yanaofikishwa kwako",
      desc: "KEDE-Water huchuja, hujaza na kufikisha maji safi ya kunywa nyumbani, madukani na ofisini kote Shanzu — maji safi bila wasiwasi.",
      features: ["Maji safi yaliyochujwa na kupimwa ubora", "Usafirishaji hadi nyumbani na ofisini Shanzu", "Kituo cha kujaza maji kwa bei nafuu"],
    },
  },
  {
    slug: "juice",
    index: "05",
    name: "KEDE-Juice",
    image: "https://images.pexels.com/photos/5668181/pexels-photo-5668181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-5",
    height: "h-96 md:h-[26rem]",
    en: {
      tagline: "Fresh-pressed juice from coastal fruit",
      desc: "A juice bar pressing the coast's best fruit every morning — mango, passion fruit, baobab and seasonal specials, always fresh.",
      features: ["Cold-pressed daily from coastal fruit", "Mango, passion, baobab & more", "No added sugar, ever"],
    },
    sw: {
      tagline: "Juisi freshi kutoka matunda ya pwani",
      desc: "Baa ya juisi inayokamua matunda bora ya pwani kila asubuhi — maembe, pasheni, baobab na vya msimu, freshi kila wakati.",
      features: ["Juisi iliyokamuliwa kila siku kutoka matunda ya pwani", "Maembe, pasheni, baobab na mengineyo", "Bila sukari ya ziada, kamwe"],
    },
  },
  {
    slug: "mobile-juice",
    index: "06",
    name: "KEDE-Mobile-Juice",
    image: "https://images.pexels.com/photos/30900665/pexels-photo-30900665.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-7",
    height: "h-96 md:h-[26rem]",
    en: {
      tagline: "Juice on wheels, all over Shanzu",
      desc: "The juice bar on wheels. Our mobile carts bring cold-pressed freshness to the beach, the market and your event.",
      features: ["Juice carts across Shanzu beach", "Events & catering service", "Same freshness, anywhere"],
    },
    sw: {
      tagline: "Juisi kwenye magurudumu, kote Shanzu",
      desc: "Baa ya juisi kwenye magurudumu. Mikokoteni yetu huleta ufreshi wa juisi ufuoni, sokoni na kwenye tukio lako.",
      features: ["Magari ya juisi kote ufuo wa Shanzu", "Huduma za matukio na shughuli", "Ufreshi ule ule, popote"],
    },
  },
  {
    slug: "cleaning",
    index: "03",
    name: "KEDE-Cleaning",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&q=80",
    span: "md:col-span-4",
    height: "h-80 md:h-96",
    en: {
      tagline: "Professional cleaning for homes & businesses",
      desc: "Professional cleaning teams for homes, offices and holiday stays — the same standard that keeps KEDE-Rooms spotless, brought to your door.",
      features: ["Trained, trusted cleaning teams", "Homes, offices & holiday stays", "Eco-friendly products"],
    },
    sw: {
      tagline: "Usafi wa kitaalamu kwa nyumba na biashara",
      desc: "Timu za usafi wa kitaalamu kwa nyumba, ofisi na malazi ya likizo — kiwango kilekile kinachoweka KEDE-Rooms safi, kimeletwa mlangoni mwako.",
      features: ["Timu za usafi zilizofundishwa na kuaminika", "Nyumba, ofisi na malazi ya likizo", "Bidhaa zisizoharibu mazingira"],
    },
  },
  {
    slug: "clothes",
    index: "04",
    name: "KEDE-Clothes",
    image: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?auto=format&fit=crop&q=80",
    span: "md:col-span-4",
    height: "h-80 md:h-96",
    en: {
      tagline: "Quality clothing, sold in Shanzu",
      desc: "KEDE-Clothes sells carefully selected clothing for the whole family — everyday wear and coastal styles at fair prices in Shanzu.",
      features: ["Clothing for women, men & children", "Quality fabrics at fair prices", "New styles every season"],
    },
    sw: {
      tagline: "Nguo bora zinazouzwa Shanzu",
      desc: "KEDE-Clothes inauza nguo zilizochaguliwa kwa makini kwa familia nzima — nguo za kila siku na mitindo ya pwani kwa bei nafuu Shanzu.",
      features: ["Nguo za wanawake, wanaume na watoto", "Kitambaa bora kwa bei nafuu", "Mitindo mipya kila msimu"],
    },
  },
  {
    slug: "internet",
    index: "07",
    name: "KeDe-IT",
    image: "https://images.unsplash.com/photo-1758874384232-cfa79a5babf1?crop=entropy&cs=srgb&fm=jpg&q=85",
    portfolio: [
      { title: "KEDE-Rooms", category: "website", url: "https://new-website-now.com/demo/kede-rooms", image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=85&w=1200" },
      { title: "KEDE-Water", category: "website", url: "https://new-website-now.com/demo/kede-water", image: "https://images.unsplash.com/photo-1602143407151-7111542de6e8?q=85&w=1200" },
      { title: "KEDE-Juice", category: "website", url: "https://new-website-now.com/demo/kede-juice", image: "https://images.unsplash.com/photo-1610970881699-44a5587cabec?q=85&w=1200" },
      { title: "Burger Basen", category: "website", url: "https://new-website-now.com/demo/fastfood", image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&q=85" },
      { title: "Den Hyggelige Taverna", category: "website", url: "https://new-website-now.com/demo/hygge-tavern", image: "https://images.unsplash.com/photo-1692455129272-60299bc2b1a8?crop=entropy&cs=srgb&fm=jpg&q=85" },
      { title: "Hansen Menswear", category: "website", url: "https://new-website-now.com/demo/herretoej", image: "https://images.unsplash.com/photo-1617137968427-85924c800a22?q=85&w=1200" },
      { title: "Atelier Nord", category: "website", url: "https://new-website-now.com/demo/toejbutik", image: "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?crop=entropy&cs=srgb&fm=jpg&q=85" },
      { title: "Golden Bites", category: "website", url: "https://new-website-now.com/demo/bageri", image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?q=85&w=1200" },
      { title: "LægeSupport", category: "website", url: "https://new-website-now.com/demo/laege-support", image: "https://images.unsplash.com/photo-1758691461935-202e2ef6b69f?crop=entropy&cs=srgb&fm=jpg&q=85" },
      { title: "Achieng for Senate 2027", category: "campaign", image: "https://images.unsplash.com/photo-1603279756527-e2705dd89f75?crop=entropy&cs=srgb&fm=jpg&q=85" },
      { title: "Baobab Stores Launch", category: "campaign", image: "https://images.unsplash.com/photo-1567958436049-f2903793328b?crop=entropy&cs=srgb&fm=jpg&q=85" },
      { title: "Savanna Social Media", category: "campaign", image: "https://images.unsplash.com/photo-1724862936518-ae7fcfc052c1?crop=entropy&cs=srgb&fm=jpg&q=85" },
      { title: "KEDE-Clothes", category: "website", url: "https://new-website-now.com/demo/kede-clothes", image: "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?q=85&w=1200" },
      { title: "KEDE-mobile-Juice", category: "website", url: "https://new-website-now.com/demo/kede-mobile-juice", image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?q=85&w=1200" },
      { title: "KEDE-Cleaning", category: "website", url: "https://new-website-now.com/demo/kede-cleaning", image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?q=85&w=1200" },
      { title: "KeDe-IT", category: "website", url: "https://new-website-now.com/demo/kede-internet", image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=85&w=1200" },
      { title: "Klart-syn", category: "website", url: "https://new-website-now.com/demo/vinduespudser", image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=85&w=1200" },
      { title: "Super VVS", category: "website", url: "https://new-website-now.com/demo/vvs", image: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?q=85&w=1200" },
      { title: "Multi-Clean Demo", category: "website", url: "https://new-website-now.com/demo/rengoring", image: "https://images.unsplash.com/photo-1603712725038-e9334ae8f39f?q=85&w=1200" },
      { title: "Craftwork Jan", category: "website", url: "https://new-website-now.com/demo/haandvaerk", image: "https://images.unsplash.com/photo-1504148455328-c376907d081c?q=85&w=1200" },
      { title: "Heights Care", category: "website", url: "https://new-website-now.com/demo/facadeservice", image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=85&w=1200" },
      { title: "Handyman Jan", category: "website", url: "https://new-website-now.com/demo/handyman", image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=85&w=1200" },
      { title: "CraftPaint Studio", category: "website", url: "https://new-website-now.com/demo/maler", image: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=85&w=1200" },
    ],
    span: "md:col-span-4",
    height: "h-80 md:h-96",
    en: {
      tagline: "Websites & digital campaigns across Kenya",
      desc: "KeDe-IT builds websites for upcoming companies and runs digital campaigns for politicians and shop chains all over Kenya — Danish design standards, Kenyan reach.",
      features: ["Websites for upcoming companies", "Campaigns for politicians", "Digital marketing for shop chains nationwide"],
    },
    sw: {
      tagline: "Tovuti na kampeni za kidijitali Kenya nzima",
      desc: "KeDe-IT hujenga tovuti kwa kampuni zinazokua na kuendesha kampeni za kidijitali kwa wanasiasa na mnyororo wa maduka Kenya nzima — viwango vya kubuni vya Denmark, ufikiaji wa Kenya.",
      features: ["Tovuti kwa kampuni zinazokua", "Kampeni kwa wanasiasa", "Umasoko wa kidijitali kwa mnyororo wa maduka nchini kote"],
    },
  },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1486718448742-163732cd1544?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhZnJpY2FuJTIwYXJjaGl0ZWN0dXJlJTIwdGVycmFjb3R0YXxlbnwwfHx8fDE3ODgxODg0ODZ8MA&ixlib=rb-4.1.0&q=85";

export const TEXTURE_IMAGE = "https://images.unsplash.com/photo-1552853519-1793ff886074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhZnJpY2FuJTIwYXJjaGl0ZWN0dXJlJTIwdGVycmFjb3R0YXxlbnwwfHx8fDE3ODgxODg0ODZ8MA&ixlib=rb-4.1.0&q=85";

const DA_CONTENT = {
  rooms: {
    tagline: "Boutique-ophold få skridt fra Shanzu Beach",
    desc: "Lyse, fejlfrie værelser og lejligheder få minutter fra Shanzu Beach' hvide sand — dansk standard for komfort leveret med kenyansk varme.",
    features: ["Daglig rengøring fra KEDE-Cleaning", "Højhastigheds Wi-Fi på alle værelser", "Frisk juice-morgenmad fra KEDE-Juice"],
  },
  water: {
    tagline: "Rent drikkevand, leveret",
    desc: "KEDE-Water renser, tapper og leverer sikkert drikkevand til hjem, butikker og kontorer i hele Shanzu — vand du aldrig behøver at tænke på.",
    features: ["Renset og kvalitetstestet drikkevand", "Levering til hjem og kontorer i Shanzu", "Prisvenlig genopfyldningsstation"],
  },
  juice: {
    tagline: "Friskpresset juice fra kystens frugt",
    desc: "En juicebar, der presser kystens bedste frugt hver morgen — mango, passionsfrugt, baobab og sæsonens specialiteter, altid frisk.",
    features: ["Koldpresset dagligt fra kystens frugt", "Mango, passionsfrugt, baobab og meget mere", "Aldrig tilsat sukker"],
  },
  "mobile-juice": {
    tagline: "Juice på hjul i hele Shanzu",
    desc: "Juicebaren på hjul. Vores mobile vogne bringer koldpresset friskhed til stranden, markedet og dit arrangement.",
    features: ["Juicevogne langs hele Shanzu-stranden", "Service til events og catering", "Samme friskhed, overalt"],
  },
  cleaning: {
    tagline: "Professionel rengøring til hjem og virksomheder",
    desc: "Professionelle rengøringsteams til hjem, kontorer og ferieboliger — samme standard, der holder KEDE-Rooms fejlfri, bragt til din dør.",
    features: ["Uddannede, pålidelige rengøringsteams", "Hjem, kontorer og ferieophold", "Miljøvenlige produkter"],
  },
  clothes: {
    tagline: "Kvalitetstøj til salg i Shanzu",
    desc: "KEDE-Clothes sælger nøje udvalgt tøj til hele familien — hverdagstøj og kystmode til fair priser i Shanzu.",
    features: ["Tøj til kvinder, mænd og børn", "Kvalitetsstof til fair priser", "Nye styles hver sæson"],
  },
  internet: {
    tagline: "Hjemmesider & digitale kampagner i hele Kenya",
    desc: "KeDe-IT bygger hjemmesider til nye virksomheder og kører digitale kampagner for politikere og butikskæder i hele Kenya — danske designstandarder, kenyansk rækkevidde.",
    features: ["Hjemmesider til nye virksomheder", "Kampagner for politikere", "Digital markedsføring for butikskæder i hele landet"],
  },
};

PROJECTS.forEach((p) => {
  p.da = DA_CONTENT[p.slug];
});
